
import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import CryptoJS from 'crypto-js';
import './css/Iniciar_sesion.css';

class Iniciar_sesion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            email: '',
            keyword: '',
            message: '',    // Añadido para manejar los mensajes
            messageType: '', // Añadido para manejar el tipo de mensaje
            username2:'', 
            password2: '', 
            email2: '',
            message2: '',    // Añadido para manejar los mensajes
            messageType2: '', // Añadido para manejar el tipo de mensaje
            ruta: 'https://www.ajesl.es:4433',
            //ruta: 'https://localhost:4433',
            ruta2: '',
            //ruta2: '',
        };
    }

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        const { username, password, email, ruta, ruta2 } = this.state;
        this.setState({ showResetPassword: false });
        // Generar el hash de la contraseña
        const hashedPassword = CryptoJS.SHA256(password).toString();

        try {
            const response = await fetch( ruta + '/logueo_usuario', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ username, password: hashedPassword, email })
            });

            if (response.ok) { // Verifica si el estado HTTP es 200-299
                const data = await response.json(); // Convierte la respuesta en JSON
                const { per, ai, acestream } = data; // Desestructura los permisos

                // Asegúrate de que `onLoginSuccess` sea una función
                if (typeof this.props.onLoginSuccess === 'function') {
                    this.props.onLoginSuccess({ username, email, per, ai, acestream, isLoggedIn: true, ruta, ruta2 }); // Pasar los permisos al componente padre
                } else {
                    this.displayMessage('onLoginSuccess no es una función', 'warning');
                }
            } else {
                console.error('Error:', 'Las credenciales son incorrectas. Por favor, inténtalo de nuevo.');
                this.displayMessage('Las credenciales son incorrectas.', 'error');
                this.setState({ showResetPassword: true });
            }
        } catch (error) {
            console.error('Error:', error);
            this.displayMessage('Error connecting to the server.' + error, 'error');
        }
    };


    handleSubmit2 = async (event) => {
        event.preventDefault();
        const { username2, password2, email2, keyword, ruta, ruta2 } = this.state;
        // Generar el hash de la contraseña
        const hashedPassword = CryptoJS.SHA256(password2).toString();

        try {
            const response = await fetch(ruta + '/crear_usuario', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ username2, password2: hashedPassword, email2, keyword })
            });

            if (response.ok) { // Verifica si el estado HTTP es 200-299
                const data = await response.json(); // Convierte la respuesta en JSON
                const { per, ai, acestream } = data; // Desestructura los permisos

                // Asegúrate de que `onLoginSuccess` sea una función
                if (typeof this.props.onLoginSuccess === 'function') {
                    this.props.onLoginSuccess({ username: username2, email: email2, per, ai, acestream, isLoggedIn: true, ruta, ruta2 }); // Pasar los permisos al componente padre
                } else {
                    this.displayMessage2('onLoginSuccess no es una función', 'warning');
                }
            } else {
                console.error('Error:', 'La Keyword indicada no está disponible.');
                this.displayMessage2('La Keyword indicada no está disponible.', 'error');
            }
        } catch (error) {
            console.error('Error:', error);
            this.displayMessage2('Error connecting to the server.', 'error');
        }
    };

    displayMessage = (message, type) => {
        this.setState({ message, messageType: type });
    }

    
    displayMessage2 = (message2, type) => {
        this.setState({ message2, messageType2: type });
    }

    handleResetPassword = async (event) => {
            event.preventDefault();
            const { email, ruta} = this.state;
            // Generar el hash de la contraseña
            if (email !== "")
                {           
            try {
                const response = await fetch(ruta + '/resetear_password', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({email})
                });
    
                if (response.ok) { // Verifica si el estado HTTP es 200-299
                    alert("El servidor le ha mandado un correo para restablecer su password");
                } 
            } catch (error) {
                console.error('Error:', error);
                this.displayMessage('Error connecting to the server.', 'error');
            }
        // Lógica para restablecer la contraseña, como redirigir a una página de restablecimiento
        console.log('Restablecimiento de contraseña solicitado');
        // Aquí podrías redirigir a una página de restablecimiento o mostrar un modal, etc.
        }
        else
        {
            alert("Tiene que rellenar el email al menos");
        }
    }

    render() {
        const { username, password, email, message, messageType, username2, password2, email2, message2, messageType2, keyword } = this.state;

        return (
            <>
                <div className='contenedor_registro_i'>
                <div className="row justify-content-center">
                <div className='col-10 col-md-5 text-center'>
                <div className='titulo_l text-center'><p>Login</p></div>
                    <form className='formulario_login_i' onSubmit={this.handleSubmit}>
                        <div className='row col-12 col-md-12'>
                            <label className='etiqueta_i col-6 col-md-6' htmlFor="username">Usuario:</label>
                            <input className='casilla_i col-6 col-md-6'
                                type="text"
                                id="username"
                                name="username"
                                value={username}
                                onChange={this.handleInputChange}
                                required
                            />
                            <label className='etiqueta_i col-6 col-md-6' htmlFor="password">Contraseña:</label>
                            <input className='casilla_i col-6 col-md-6'
                                type="password"
                                id="password"
                                name="password"
                                value={password}
                                onChange={this.handleInputChange}
                                required
                            />
                            <label className='etiqueta_i col-6 col-md-6' htmlFor="email">Email:</label>
                            <input className='casilla_i col-6 col-md-6'
                                type="email"
                                id="email"
                                name="email"
                                value={email}
                                onChange={this.handleInputChange}
                                required
                            />
                        </div>
                        <p></p>
                        <p></p>
                        <div className='row col-12 col-md-12'>
                            <div className='blanco col-6 col-md-6'></div>
                            <button className='boton_login col-6 col-md-6' type="submit">Iniciar Sesión</button>
                        </div>
                        <p></p>
                        <div className='row col-12 centrar'>
                            <div className={`messageBox ${messageType} col-11 centrar`}>{message}</div> {/* Mostrar el mensaje */}
                            {this.state.showResetPassword && (
                                <>
                                    <div className='row error col-11 d-flex centrar'>Por favor, inténtalo de nuevo.</div>
                                    <div className='row reset-password'>
                                        <p></p>
                                        <div className='row col-12'>
                                            <div className='blanco col-6'></div>
                                            <button className='boton_login col-6' onClick={this.handleResetPassword}>Restablecer Contraseña</button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                        <p></p>
                    </form>
                    </div>
                    <div className='col-10 col-md-5 text-center'>
                    <div className='titulo_l text-center'><p>Crear Usuario</p></div>
                    <form className='formulario_login_i' onSubmit={this.handleSubmit2}>
                        <div className='row col-12 col-md-12'>
                            <label className='etiqueta_i col-6 col-md-6' htmlFor="username">Usuario:</label>
                            <input className='casilla_i col-6 col-md-6'
                                type="text"
                                id="username2"
                                name="username2"
                                value={username2}
                                onChange={this.handleInputChange}
                                required
                            />
                            <p></p>
                            <label className='etiqueta_i col-6 col-md-6' htmlFor="password">Contraseña:</label>
                            <input className='casilla_i col-6 col-md-6'
                                type="password"
                                id="password2"
                                name="password2"
                                value={password2}
                                onChange={this.handleInputChange}
                                required
                            />
                            <p></p>
                            <label className='etiqueta_i col-6 col-md-6' htmlFor="email">Email:</label>
                            <input className='casilla_i col-6 col-md-6'
                                type="email"
                                id="email2"
                                name="email2"
                                value={email2}
                                onChange={this.handleInputChange}
                                required
                            />
                            <p></p>
                            <label className='etiqueta_i col-6 col-md-6' htmlFor="keyword">Keyword:</label>
                            <input className='casilla_i col-6 col-md-6'
                                type="text"
                                id="keyword"
                                name="keyword"
                                value={keyword}
                                onChange={this.handleInputChange}
                                required
                            />
                        </div>
                        <p></p>
                        <p></p>
                        <div className='row col-12 col-md-12'>
                            <div className='blanco col-6 col-md-6'></div>
                            <button className='boton_login col-6 col-md-6' type="submit">Crear Usuario</button>
                        </div>
                        <p></p>
                        <div className='centrar col-12'>
                            <div className={`messageBox ${messageType2}`}>{message2}</div> {/* Mostrar el mensaje */}
                        </div>
                        <p></p>
                    </form>
                </div>
                </div>
                </div>
            </>
        );
    }
}

export default Iniciar_sesion;
